// @ts-ignore
import styled from 'styled-components';

import { themeColors } from 'theme';

// @ts-ignore
export const ErrorText = styled.div`
  color: ${themeColors.warning};
  font-size: 0.8rem;
  font-weight: bold;
  margin-top: 5px;
`;
